import { NSButton, NSLoadingScreen } from 'bricks';
import { useState } from 'react';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { NSButtonBase } from 'bricks/NSButton/NSButton';
import { useQuery } from '@tanstack/react-query';
import CompanyCard from './CompanyCard';
import ViewAllModal from './ViewAllModal';
import getCRMDealCompaniesQueryOptions from './hooks/useGetCRMDealCompanies';
import UpsertCompaniesModal from './UpsertCompaniesModal';

export interface IDealCompaniesProps {
    organizationId: string;
    dealId: number;
}

const Companies = ({ organizationId, dealId }: IDealCompaniesProps) => {
    const maxToDisplay = 3;
    const [showAll, setShowAll] = useState(false);
    const [showUpsertModal, setShowUpsertModal] = useState(false);

    const {
        data: companies,
        isSuccess,
    } = useQuery(getCRMDealCompaniesQueryOptions(organizationId, dealId));

    return isSuccess ? (
        <div className="border-bottom p-2">
            <div className="d-flex justify-content-between align-items-center">
                <h5 className="text-white font-weight-bold my-1">
                    {`Companies (${companies.length})`}
                </h5>
                <NSButton
                    icon="plus"
                    text="Associate company"
                    className="text-primary p-0 d-block font-weight-normal heap-deal-activity-associate-company"
                    callback={() => setShowUpsertModal(!showUpsertModal)}
                />
            </div>

            {companies
                .slice(0, maxToDisplay)
                .map(company => <CompanyCard key={company.correlationId} {...company} />)}

            {companies.length > maxToDisplay && (
                <NSButtonBase
                    callback={() => setShowAll(!showAll)}
                    text="View all associated companies"
                    icon={faChevronRight}
                    iconPosition="right"
                    className="font-weight-normal text-primary p-0 heap-deal-activity-view-associated-companies"
                />
            )}

            <ViewAllModal
                isOpen={showAll}
                toggle={() => setShowAll(!showAll)}
                title="View all associated companies"
            >
                { companies.map(company => <CompanyCard key={company.correlationId} {...company} />) }
            </ViewAllModal>

            {!!showUpsertModal && (
                <UpsertCompaniesModal
                    isOpen={showUpsertModal}
                    organizationId={organizationId}
                    dealId={dealId}
                    toggle={() => setShowUpsertModal(!showUpsertModal)}
                    existingAssociations={companies}
                />
            )}

        </div>

    ) : (
        <NSLoadingScreen />
    );
};

export default Companies;
